import { render, staticRenderFns } from "./tuiguang.vue?vue&type=template&id=241630a7&scoped=true"
import script from "./tuiguang.vue?vue&type=script&lang=js"
export * from "./tuiguang.vue?vue&type=script&lang=js"
import style0 from "./tuiguang.vue?vue&type=style&index=0&id=241630a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241630a7",
  null
  
)

export default component.exports